import React from 'react';
import { FINANCIAL_STATUS_CONFIG } from '../constants/financialStatus';

/**
 * Badge de statut financier réutilisable, aligné sur le workflow canonique.
 * Usage : <FinancialStatusBadge status="invoiced" />
 */
export const FinancialStatusBadge = ({ status, className = '' }) => {
  const cfg = FINANCIAL_STATUS_CONFIG[status];
  if (!cfg) return <span className="text-xs text-gray-400">—</span>;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded-full ${cfg.bg} ${cfg.text} ${className}`}
      data-testid="financial-status-badge"
    >
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
};

export default FinancialStatusBadge;
